import { neededBy } from './needed-by.js';
/** The View keys a set of grants needs but doesn't hold, so a role can't open a screen whose pages then come back blank. */
export function unmetNeeds(granted) {
    const held = new Set(granted);
    return [...neededBy(held)]
        .filter(([permission]) => !held.has(permission))
        .map(([permission, modules]) => ({ permission, neededBy: modules }))
        .sort((left, right) => left.permission.localeCompare(right.permission));
}
//# sourceMappingURL=unmet-needs.js.map